const isMenuItemVisible = (item, checkRoles) => {
  if (item.requireRoleList && !checkRoles(
    item.requireRoleList,
    item.isCheckCorporateCode,
    item.rootAdminRole
  )) {
    return false;
  }
  if (item.denyRoleList && checkRoles(item.denyRoleList)) {
    return false;
  }
  if (item.type === "expand") {
    return item.children.some((child) => isMenuItemVisible(child, checkRoles));
  }
  return true;
};
export {
  isMenuItemVisible
};
